import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState, updateArrayState } from "../utils";
import log from "../../utils/log";

const useShopStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      /**
       * Updates the cache of shops in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {string} query - query URL. eg: ?pagination=1
       * @param {Array} param - An array containing the shop object(s) to be added, updated, or deleted.
       */
      updateShopsCache: (action, query, param) => {
        set({ shopsCache: updateObjectState(get().shopsCache, action, { [query]: param }) });
      },
      /**
       * Updates the cache of a single shop in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {Array} param - An array containing the shop object(s) to be added, updated, or deleted.
       */
      updateSingleShopCache: (action, param) => {
        set({ singleShopCache: updateArrayState(get().singleShopCache, action, param) });
      },
      resetShop: () => set(initialState), // Reset function
      //getter
      getShops: (query) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return [obj] if has cache of provided query
        return get().shopsCache[query];
      },
      getSingleShop: (id) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return obj if has cache of provided id
        if (!id) {
          return undefined;
        }
        return get().singleShopCache.find((e) => e.id === id);
      },
    })),
    {
      name: "pearl-shop", //name of store, must be unique
      storage: createJSONStorage(() => sessionStorage), // Use session storage
    }
  )
);

export default useShopStore;
